import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Chessboard = ({ children, deeplinkId }) => {
  let rows = [[children]];
  if (children && children.length > 1) {
    // creates chessboard rows consisting of two chessboard items
    let add = 0;
    rows = children.reduce((rows, key, index) => {
      // If the item type is an image, it will solely fill that row without any other item
      if (key.props.image) {
        add++;
      }
      if ((index + add) % 2 === 0 || key.props.image) {
        rows.push([key]);
      } else {
        rows[rows.length - 1].push(key);
      }
      return rows;
    }, []);
  }

  return (
    <div className={cx('chessboard')} id={deeplinkId}>
      {rows.map((items, i) => (
        <div key={i} className={styles.row}>
          {items.map((item) => item)}
        </div>
      ))}
    </div>
  );
};

Chessboard.propTypes = {
  children: PropTypes.node,
  deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Chessboard;
